// src/ocrAddress.js
import { createWorker } from 'tesseract.js';

let workerPromise = null;

// Worker nur einmal erstellen (sonst wird es schnell sehr langsam)
async function getWorker() {
  if (!workerPromise) {
    workerPromise = (async () => {
      const worker = await createWorker({
        logger: m => console.log('[Tesseract]', m) // optional: Fortschritt in der Konsole
      });
      await worker.loadLanguage('deu+eng'); // Deutsch + Englisch
      await worker.initialize('deu+eng');
      return worker;
    })();
  }
  return workerPromise;
}

// Einfache Heuristik, um aus OCR-Text eine Adresse zu ziehen
function parseAddressFromText(text) {
  // Zeilen aufbereiten
  const lines = text
    .split('\n')
    .map(l => l.trim())
    .filter(Boolean);

  if (lines.length === 0) return null;

  // Zeile mit PLZ (Schweiz: 4-stellig) suchen
  const plzIndex = lines.findIndex(line => /\b\d{4}\b/.test(line));
  if (plzIndex === -1) return null;

  const plzLine = lines[plzIndex];
  const plzMatch = plzLine.match(/\b(\d{4})\s+(.+)/);

  if (!plzMatch) return null;

  const plz = plzMatch[1];
  const ort = plzMatch[2].trim();

  // Strasse/Nummer typischerweise Zeile darüber
  const streetLine = lines[plzIndex - 1] || '';

  // Name typischerweise Zeile darüber
  const nameLine = lines[plzIndex - 2] || '';

  const parts = [];
  if (nameLine) parts.push(nameLine);
  if (streetLine) parts.push(streetLine);
  parts.push(`${plz} ${ort}`);

  return parts.join(', ');
}

/**
 * Führt OCR auf einem Bild (Data-URL) durch und versucht, die Empfängeradresse zu extrahieren.
 * @param {string} imageDataUrl - data:image/jpeg;base64,...
 * @returns {Promise<{ rawText: string, address: string | null }>}
 */
export async function extractAddressFromImage(imageDataUrl) {
  const worker = await getWorker();
  const { data } = await worker.recognize(imageDataUrl);

  const rawText = data.text || '';
  const address = parseAddressFromText(rawText);

  return { rawText, address };
}
